import { useMemo } from "react";

import { formatDateDisplay } from "@/helpers/parsers";
import type { GameType } from "@/pages/company/types";
import { GameStatusEnum } from "@/pages/search/types";

interface ComingSoonProps {
  game: GameType;
}

export default function ComingSoon({ game }: ComingSoonProps) {
  const label = useMemo(() => {
    if (!game.openingAt) {
      return "🚀 COMING SOON";
    }

    return `🚀 Opening ${formatDateDisplay(game.openingAt, false)}`;
  }, [game.openingAt]);

  if (game.status !== GameStatusEnum.CS) {
    return null;
  }

  return (
    <div className="absolute inset-x-0 bottom-0 flex h-8 items-center justify-center bg-deep-lavender/80 bg-linear-91 from-mystic-red/10 to-electric-purple/10 backdrop-blur-[2px]">
      <p className="text-center font-medium text-16 text-shadow-0-0-6 text-shadow-black/30 text-white">
        {label}
      </p>
    </div>
  );
}
